<app-sidebar-navigation></app-sidebar-navigation>
<!--site header begins-->
<app-header (refreshMainComponet)="refreshMainComponent($event)"></app-header>
@if (showMainComponent) {
  <router-outlet></router-outlet>
}

@if (loading) {
  <div class="loader-container">
    <div class="loader"></div>
    <!-- Loading, please wait... -->
  </div>
}

@if (isImpersonating) {
  <div class="impersonation-banner">
    <span>You are viewing this instance as an impersonated user.</span>
    <button class="btn btn-sm btn-light ml-2" (click)="endImpersonation()">End Session</button>
  </div>
}

<!--
  Buddy lives in the authenticated shell only, so it never appears on /auth/**.
  Collapsed by default; Alt+Space or a click on the bubble wakes the panel.
-->
<app-buddy-host *ngIf="enableBuddyFeatures"></app-buddy-host>
